var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { Stack, Typography, Grid, Box, FormGroup, FormControlLabel, Checkbox, Tooltip, IconButton, CircularProgress, Tab, Tabs } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import PercentIcon from '@mui/icons-material/Percent';
import PictureAsPdfRoundedIcon from '@mui/icons-material/PictureAsPdfRounded';
import DescriptionRoundedIcon from '@mui/icons-material/DescriptionRounded';
import MailRoundedIcon from '@mui/icons-material/MailRounded';
import GridOnRoundedIcon from '@mui/icons-material/GridOnRounded';
import ImageRoundedIcon from '@mui/icons-material/ImageRounded';
import InsertDriveFileRoundedIcon from '@mui/icons-material/InsertDriveFileRounded';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import JSZip from 'jszip';
import { baseColors } from '../../Themes/colors';
import PlagiarismOutlinedIcon from '@mui/icons-material/PlagiarismOutlined';
import TuneIcon from '@mui/icons-material/Tune';
import TextBottomLine from '../../components/uiComponents/TextBottomLine';
import TextField from '../../components/FormComponents/TextField';
import { CheckboxWrapper } from './Backlog';
import AutoCompleteDD from '../../components/FormComponents/AutoCompleteDD';
import { ConditionRow } from './BacklogApplicationStyles';
import BacklogComments from './BacklogComments';
import { CreditToleranceIcon, DocumentsIcon, ArrowRightIcon } from '../../components/icons';
import { api_service } from '../../api/api_service';
import { api_urls } from '../../api/api_urls';
import constants from '../../config/constants';
import { utility } from '../../utils';
import { downloadBlob } from '../../utils/commonUtilities';
import { NavigationConfig } from '../../utils/navigation_config';
import ConfirmationAndInformationPoup, { POPUP_TYPE } from '../../components/UtilityComponents/ConfirmationAndInformationPoup';
import FundingLogActionsCard from './fundingLog/FundingLogActionsCard';
import FundingLogReassignPopup from './fundingLog/FundingLogReassignPopup';
import { deriveFundingLogCanManage, deriveFundingLogRoleTier, isFundingLogReviewerRole, useFundingLogRowActions, FUNDING_LOG_CONTRACT_STATUS, } from './fundingLog/useFundingLog';
var SectionIconBadge = function (_a) {
    var bgColor = _a.bgColor, children = _a.children;
    return (React.createElement(Box, { sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 32,
            height: 32,
            borderRadius: '10px',
            backgroundColor: bgColor,
            flexShrink: 0,
            '& svg': { width: 18, height: 18 },
        } }, children));
};
var drawerTypes = {
    CREDIT_CONDITIONS: 'Credit Conditions',
    CONTRACT_TOLERANCE: 'Contract Tolerance',
    COMMENTS: 'Add Comment',
};
var rolesList = {
    status: [
        { Id: '1', Name: 'Pending' },
        { Id: '2', Name: 'Approved' },
        { Id: '3', Name: 'Rejected' }
    ],
};
var formSections = [
    {
        label: "Approved Finance Amount",
        icon: "icon-doller",
        fields: [
            { name: "ApprovedFinanceAmount", placeholder: "Approved Finance Amount", type: "number", isToleranceField: true },
            { name: "AmountFinanced", placeholder: "Amount Financed", type: "text" },
        ],
    },
    {
        label: "Minimum Yield",
        icon: React.createElement(PercentIcon, { sx: { fontSize: 18 } }),
        fields: [
            { name: "MinimumYield", placeholder: "Minimum Yield", type: "number", isToleranceField: true },
            { name: "YieldRate", placeholder: "Yield Rate", type: "text" },
        ],
    },
    {
        label: "Maximum Term",
        icon: "icon-Date",
        fields: [
            { name: "MaximumTerm", placeholder: "Maximum Term", type: "text", isToleranceField: true },
            { name: "Term", placeholder: "Term", type: "text" },
        ],
    },
];
var RightSection = function (_a) {
    var _b;
    var appResp = _a.appResp, roleType = _a.roleType, mainResp = _a.mainResp, _c = _a.documents, documents = _c === void 0 ? [] : _c, _d = _a.tabs, tabs = _d === void 0 ? [] : _d, _e = _a.isDocumentPreviewOpen, isDocumentPreviewOpen = _e === void 0 ? false : _e, selectedDocumentId = _a.selectedDocumentId, _f = _a.activePreviewSection, activePreviewSection = _f === void 0 ? 'documents' : _f, onDocumentOpen = _a.onDocumentOpen, onCreditReportOpen = _a.onCreditReportOpen, _g = _a.creditReportItems, creditReportItems = _g === void 0 ? [] : _g, handleDocumentPreviewClose = _a.handleDocumentPreviewClose, onCompactModeChange = _a.onCompactModeChange, fundingLogRow = _a.fundingLogRow;
    var _h = useState(null), activeDrawer = _h[0], setActiveDrawer = _h[1];
    var _j = useState(false), showExpandedDocuments = _j[0], setShowExpandedDocuments = _j[1];
    var _k = useState(false), showExpandedComments = _k[0], setShowExpandedComments = _k[1];
    var _l = useState(false), showDefaultView = _l[0], setShowDefaultView = _l[1];
    var _m = useState(null), activeCompactPanel = _m[0], setActiveCompactPanel = _m[1];
    var _o = useState(false), isDownloadingAllDocuments = _o[0], setIsDownloadingAllDocuments = _o[1];
    var _p = React.useState(''), commentSubject = _p[0], setCommentSubject = _p[1];
    var _q = React.useState(''), commentText = _q[0], setCommentText = _q[1];
    var _r = React.useState([]), comments = _r[0], setComments = _r[1];
    var _s = useState(fundingLogRow !== null && fundingLogRow !== void 0 ? fundingLogRow : null), actionRow = _s[0], setActionRow = _s[1];
    useEffect(function () {
        setActionRow(fundingLogRow !== null && fundingLogRow !== void 0 ? fundingLogRow : null);
    }, [fundingLogRow]);
    var _t = useState(null), pendingFundingAction = _t[0], setPendingFundingAction = _t[1];
    var _u = useState(false), isFundingAssignErrorPopupOpen = _u[0], setIsFundingAssignErrorPopupOpen = _u[1];
    var _v = useState(false), isReassignPopupOpen = _v[0], setIsReassignPopupOpen = _v[1];
    var _w = useState([]), cmMembers = _w[0], setCmMembers = _w[1];
    var _x = useState(false), isLoadingCmMembers = _x[0], setIsLoadingCmMembers = _x[1];
    var _y = useState(false), isReassignSubmitting = _y[0], setIsReassignSubmitting = _y[1];
    var hasFetchedCmMembersRef = useRef(false);
    var accountAspireOId = useSelector(function (store) { var _a; return (_a = store.User.userData) === null || _a === void 0 ? void 0 : _a.AccountAspireOId; });
    var currentUserRoleDescription = useSelector(function (store) { var _a; return (_a = store.User.userData) === null || _a === void 0 ? void 0 : _a.RoleDescription; });
    var currentUserRoleTier = deriveFundingLogRoleTier(currentUserRoleDescription);
    var currentUserIsReviewer = isFundingLogReviewerRole(currentUserRoleDescription);
    var _z = useFundingLogRowActions(), assignFundingRowToMe = _z.assignToMe, moveFundingRowToL2Manager = _z.moveToL2Manager, updateFundingRowContractStatus = _z.updateBacklogContractStatus, fetchContractManagers = _z.fetchContractManagers;
    var canManageFundingActions = actionRow ? currentUserIsReviewer && deriveFundingLogCanManage(actionRow, accountAspireOId, currentUserRoleTier) : false;
    var navigate = useNavigate();
    var goToFundingLogQueue = function () { return navigate(NavigationConfig.FundingLogManagement); };
    var handleOpenReassignPopup = function () {
        setIsReassignPopupOpen(true);
        if (!hasFetchedCmMembersRef.current) {
            hasFetchedCmMembersRef.current = true;
            setIsLoadingCmMembers(true);
            fetchContractManagers()
                .then(setCmMembers)
                .finally(function () { return setIsLoadingCmMembers(false); });
        }
    };
    var handleFundingAssignToMyself = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!actionRow)
                        return [2];
                    return [4, assignFundingRowToMe(actionRow.id)];
                case 1:
                    result = _a.sent();
                    if (result.accountNotInAspire) {
                        setIsFundingAssignErrorPopupOpen(true);
                        return [2];
                    }
                    if (result.success) {
                        goToFundingLogQueue();
                    }
                    return [2];
            }
        });
    }); };
    var handleConfirmFundingAction = function () { return __awaiter(void 0, void 0, void 0, function () {
        var action, success_1, contractStatus, success;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    action = pendingFundingAction;
                    setPendingFundingAction(null);
                    if (!action || !actionRow)
                        return [2];
                    if (!(action === 'l2')) return [3, 2];
                    return [4, moveFundingRowToL2Manager(actionRow.id)];
                case 1:
                    success_1 = _a.sent();
                    if (success_1) {
                        goToFundingLogQueue();
                    }
                    return [2];
                case 2:
                    contractStatus = action === 'funded' ? FUNDING_LOG_CONTRACT_STATUS.FUNDED : FUNDING_LOG_CONTRACT_STATUS.SALES_SUPPORT;
                    return [4, updateFundingRowContractStatus(actionRow, contractStatus)];
                case 3:
                    success = _a.sent();
                    if (success && action === 'funded') {
                        setActionRow(function (prev) { return (prev ? __assign(__assign({}, prev), { status: 'Booked' }) : prev); });
                    }
                    if (success) {
                        goToFundingLogQueue();
                    }
                    return [2];
            }
        });
    }); };
    var handleReassignConfirm = function (memberId) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!actionRow)
                        return [2];
                    setIsReassignSubmitting(true);
                    return [4, assignFundingRowToMe(actionRow.id, memberId)];
                case 1:
                    result = _a.sent();
                    setIsReassignSubmitting(false);
                    if (result.success) {
                        setIsReassignPopupOpen(false);
                        goToFundingLogQueue();
                    }
                    return [2];
            }
        });
    }); };
    var getDocumentName = function (doc) { return (doc === null || doc === void 0 ? void 0 : doc.DocumentName) || (doc === null || doc === void 0 ? void 0 : doc.FileName) || '--'; };
    var DOCUMENT_TYPE_STYLES = {
        pdf: { icon: PictureAsPdfRoundedIcon, color: '#E7543D', label: 'PDF' },
        doc: { icon: DescriptionRoundedIcon, color: '#4D6DB7', label: 'Word Document' },
        docx: { icon: DescriptionRoundedIcon, color: '#4D6DB7', label: 'Word Document' },
        eml: { icon: MailRoundedIcon, color: '#D98F00', label: 'Email' },
        msg: { icon: MailRoundedIcon, color: '#D98F00', label: 'Email' },
        xls: { icon: GridOnRoundedIcon, color: '#4E924F', label: 'Excel Sheet' },
        xlsx: { icon: GridOnRoundedIcon, color: '#4E924F', label: 'Excel Sheet' },
        jpg: { icon: ImageRoundedIcon, color: '#7C4DFF', label: 'Image' },
        jpeg: { icon: ImageRoundedIcon, color: '#7C4DFF', label: 'Image' },
        png: { icon: ImageRoundedIcon, color: '#7C4DFF', label: 'Image' },
        txt: { icon: InsertDriveFileRoundedIcon, color: baseColors.greyPreset[5], label: 'Text File' },
        html: { icon: InsertDriveFileRoundedIcon, color: baseColors.greyPreset[5], label: 'HTML File' },
    };
    var DEFAULT_DOCUMENT_TYPE_STYLE = { icon: InsertDriveFileRoundedIcon, color: baseColors.greyPreset[5], label: 'File' };
    var getDocumentExtension = function (doc) {
        var name = getDocumentName(doc);
        var ext = typeof name === 'string' ? name.split('.').pop() : '';
        return (ext || '').toLowerCase();
    };
    var getDocumentTypeStyle = function (doc) {
        return DOCUMENT_TYPE_STYLES[getDocumentExtension(doc)] || DEFAULT_DOCUMENT_TYPE_STYLE;
    };
    var getLightTint = function (hex, amount) {
        if (amount === void 0) { amount = 0.85; }
        var normalized = hex.replace('#', '');
        if (normalized.length !== 6)
            return hex;
        var r = parseInt(normalized.slice(0, 2), 16);
        var g = parseInt(normalized.slice(2, 4), 16);
        var b = parseInt(normalized.slice(4, 6), 16);
        var mix = function (channel) { return Math.round(channel + (255 - channel) * amount); };
        return "rgb(".concat(mix(r), ", ").concat(mix(g), ", ").concat(mix(b), ")");
    };
    var renderDocumentTypeTag = function (doc, size) {
        if (size === void 0) { size = 26; }
        var _a = getDocumentTypeStyle(doc), TypeIcon = _a.icon, color = _a.color, label = _a.label;
        return (React.createElement(Tooltip, { title: label, placement: "top", arrow: true },
            React.createElement(Box, { sx: {
                    width: size,
                    height: size,
                    borderRadius: '7px',
                    backgroundColor: getLightTint(color),
                    color: color,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                } },
                React.createElement(TypeIcon, { sx: { fontSize: size * 0.55 } }))));
    };
    var getDocumentTypeDisplayLabel = function (documentType) { return (documentType.toLowerCase().includes('email') ? 'Email' : documentType); };
    var renderDocumentTypeChip = function (doc) {
        var _a, _b;
        var documentType = (_b = (_a = doc === null || doc === void 0 ? void 0 : doc.DocumentType) === null || _a === void 0 ? void 0 : _a.trim) === null || _b === void 0 ? void 0 : _b.call(_a);
        if (!documentType)
            return null;
        return (React.createElement(Box, { component: "span", sx: {
                display: 'inline-block',
                flexShrink: 0,
                px: 0.5,
                py: 0.15,
                borderRadius: '4px',
                fontSize: 8,
                fontWeight: 500,
                lineHeight: 1.4,
                color: baseColors.fullBlack,
                backgroundColor: baseColors.greyPreset[55],
            } }, getDocumentTypeDisplayLabel(documentType)));
    };
    var getDocumentRawTimestamp = function (doc) {
        var timestampValue = (doc === null || doc === void 0 ? void 0 : doc.UploadedDate)
            || (doc === null || doc === void 0 ? void 0 : doc.UploadDate)
            || (doc === null || doc === void 0 ? void 0 : doc.DocumentDate)
            || (doc === null || doc === void 0 ? void 0 : doc.CreatedTime)
            || (doc === null || doc === void 0 ? void 0 : doc.CreatedDate)
            || (doc === null || doc === void 0 ? void 0 : doc.ModifiedDate)
            || (doc === null || doc === void 0 ? void 0 : doc.LastModifiedDate)
            || (doc === null || doc === void 0 ? void 0 : doc.CreatedOn)
            || (doc === null || doc === void 0 ? void 0 : doc.UpdatedOn);
        return timestampValue;
    };
    var getDocumentTimestampMs = function (doc) {
        var timestampValue = getDocumentRawTimestamp(doc);
        var parsedTimestamp = new Date(timestampValue).getTime();
        return Number.isNaN(parsedTimestamp) ? 0 : parsedTimestamp;
    };
    var formatDocumentTimestamp = function (doc) {
        var timestampValue = getDocumentRawTimestamp(doc);
        if (!timestampValue)
            return '--';
        var formatDate = function (date) {
            return date ? moment.utc(date).format('MM-DD-YYYY hh:mm:ss A') : '--';
        };
        return timestampValue ? formatDate(timestampValue) : '--';
    };
    var sortedDocuments = React.useMemo(function () {
        if (!Array.isArray(documents) || documents.length === 0) {
            return [];
        }
        return __spreadArray([], documents, true).sort(function (firstDoc, secondDoc) { return getDocumentTimestampMs(secondDoc) - getDocumentTimestampMs(firstDoc); });
    }, [documents]);
    var _0 = useState('all'), documentTab = _0[0], setDocumentTab = _0[1];
    var isEmailDocument = function (doc) { var _a; return String((_a = doc === null || doc === void 0 ? void 0 : doc.DocumentType) !== null && _a !== void 0 ? _a : '').toLowerCase().includes('email'); };
    var emailDocumentCount = React.useMemo(function () { return sortedDocuments.filter(isEmailDocument).length; }, [sortedDocuments]);
    var tabbedDocuments = React.useMemo(function () { return (documentTab === 'email'
        ? sortedDocuments.filter(isEmailDocument)
        : documentTab === 'documents'
            ? sortedDocuments.filter(function (doc) { return !isEmailDocument(doc); })
            : sortedDocuments); }, [sortedDocuments, documentTab]);
    var documentTabs = (React.createElement(Tabs, { value: documentTab, onChange: function (_event, nextTab) { return setDocumentTab(nextTab); }, variant: "fullWidth", sx: {
            minHeight: 28,
            borderBottom: "1px solid ".concat(baseColors.greyPreset[40]),
            '& .MuiTabs-indicator': { backgroundColor: baseColors.successPreset[30] },
        } }, [
        { value: 'all', label: "All (".concat(sortedDocuments.length, ")") },
        { value: 'documents', label: "Documents (".concat(sortedDocuments.length - emailDocumentCount, ")") },
        { value: 'email', label: "Email (".concat(emailDocumentCount, ")") },
    ].map(function (tab) { return (React.createElement(Tab, { key: tab.value, value: tab.value, label: tab.label, sx: { textTransform: 'none', fontSize: 12, fontWeight: 600, minHeight: 28, minWidth: 0, px: 1, py: 0.5, '&.Mui-selected': { color: baseColors.successPreset[30] } } })); })));
    var _1 = useState(function () { return (typeof window !== 'undefined' ? window.innerHeight : 900); }), viewportHeight = _1[0], setViewportHeight = _1[1];
    React.useEffect(function () {
        var handleResize = function () { return setViewportHeight(window.innerHeight); };
        window.addEventListener('resize', handleResize);
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    var visibleDocumentCount = React.useMemo(function () {
        var BASELINE_VIEWPORT_HEIGHT = 900;
        var BASELINE_COUNT = 4;
        var ROW_HEIGHT = 54;
        if (viewportHeight <= BASELINE_VIEWPORT_HEIGHT)
            return BASELINE_COUNT;
        var extraRows = Math.floor((viewportHeight - BASELINE_VIEWPORT_HEIGHT) / ROW_HEIGHT);
        return BASELINE_COUNT + extraRows;
    }, [viewportHeight]);
    var latestFourDocuments = React.useMemo(function () { return tabbedDocuments.slice(0, visibleDocumentCount); }, [tabbedDocuments, visibleDocumentCount]);
    var commentsListMaxHeight = React.useMemo(function () {
        var BASELINE_VIEWPORT_HEIGHT = 900;
        var BASELINE_HEIGHT = 300;
        if (viewportHeight <= BASELINE_VIEWPORT_HEIGHT)
            return BASELINE_HEIGHT;
        return BASELINE_HEIGHT + (viewportHeight - BASELINE_VIEWPORT_HEIGHT);
    }, [viewportHeight]);
    var hasReportsTab = React.useMemo(function () { return (Array.isArray(tabs)
        && tabs.some(function (tab) { return ((tab === null || tab === void 0 ? void 0 : tab.label) || '').trim().toLowerCase() === 'reports'; })); }, [tabs]);
    React.useEffect(function () {
        if (Array.isArray(mainResp === null || mainResp === void 0 ? void 0 : mainResp.Comments)) {
            setComments(mainResp.Comments);
        }
    }, [mainResp === null || mainResp === void 0 ? void 0 : mainResp.Comments]);
    React.useEffect(function () {
        if (isDocumentPreviewOpen) {
            setShowExpandedDocuments(false);
            setShowExpandedComments(false);
            setShowDefaultView(false);
            setActiveCompactPanel(null);
        }
    }, [isDocumentPreviewOpen]);
    React.useEffect(function () {
        var isCompactMode = Boolean(isDocumentPreviewOpen
            && !showExpandedDocuments
            && !showExpandedComments
            && !showDefaultView
            && !activeCompactPanel);
        onCompactModeChange === null || onCompactModeChange === void 0 ? void 0 : onCompactModeChange(isCompactMode);
    }, [
        isDocumentPreviewOpen,
        showExpandedDocuments,
        showExpandedComments,
        showDefaultView,
        activeCompactPanel,
        onCompactModeChange,
    ]);
    var fetchComments = function (txAspireOId) { return __awaiter(void 0, void 0, void 0, function () {
        var res, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4, api_service.get({
                            endPoint: api_urls.BACKLOG_COMMENTS,
                            payLoad: { TxAspireOId: txAspireOId, CommentTypes: ['PORTCOMMCOMPANY', 'SALES', 'FUNDLOG'] },
                            showLoader: false,
                        })];
                case 1:
                    res = _c.sent();
                    return [2, ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.statusCode) === 200 && Array.isArray((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.data) ? res.data.data : []];
                case 2:
                    error_1 = _c.sent();
                    return [2, []];
                case 3: return [2];
            }
        });
    }); };
    var handleAddComment = function (_a) {
        var subject = _a.subject, message = _a.message, CommentType = _a.CommentType;
        return __awaiter(void 0, void 0, void 0, function () {
            var trimmedSubject, trimmedMessage, txAspireOId, payload, response, refreshedComments, raw_1, error_2;
            var _b, _c, _d, _e, _f, _g, _h;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        trimmedSubject = subject.trim();
                        trimmedMessage = message.trim();
                        txAspireOId = (_b = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _b === void 0 ? void 0 : _b.TxAspireOId;
                        if (!trimmedSubject || !trimmedMessage) {
                            return [2, false];
                        }
                        if (!txAspireOId) {
                            utility.alert('Unable to add comment. Missing application identifier.', constants.TOAST_TYPES.ERROR);
                            return [2, false];
                        }
                        _j.label = 1;
                    case 1:
                        _j.trys.push([1, 5, , 6]);
                        payload = {
                            TxAspireOId: txAspireOId,
                            Subject: trimmedSubject,
                            Text: trimmedMessage,
                            CommentType: {
                                Code: CommentType.Code,
                                Description: CommentType.Description,
                            },
                        };
                        return [4, api_service.post({
                                endPoint: api_urls.BACKLOG_COMMENT,
                                payLoad: payload,
                            })];
                    case 2:
                        response = _j.sent();
                        if (!(((_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.statusCode) === 200)) return [3, 4];
                        return [4, fetchComments(txAspireOId)];
                    case 3:
                        refreshedComments = _j.sent();
                        if (refreshedComments.length > 0) {
                            setComments(refreshedComments);
                        }
                        else {
                            raw_1 = (_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.data;
                            setComments(function (prev) {
                                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
                                return __spreadArray(__spreadArray([], prev, true), [{
                                        Text: (_c = (_b = (_a = raw_1 === null || raw_1 === void 0 ? void 0 : raw_1.Text) !== null && _a !== void 0 ? _a : raw_1 === null || raw_1 === void 0 ? void 0 : raw_1.CommentText) !== null && _b !== void 0 ? _b : raw_1 === null || raw_1 === void 0 ? void 0 : raw_1.Description) !== null && _c !== void 0 ? _c : trimmedMessage,
                                        Subject: (_e = (_d = raw_1 === null || raw_1 === void 0 ? void 0 : raw_1.Subject) !== null && _d !== void 0 ? _d : raw_1 === null || raw_1 === void 0 ? void 0 : raw_1.CommentSubject) !== null && _e !== void 0 ? _e : trimmedSubject,
                                        CommentedBy: (_g = (_f = raw_1 === null || raw_1 === void 0 ? void 0 : raw_1.CommentedBy) !== null && _f !== void 0 ? _f : raw_1 === null || raw_1 === void 0 ? void 0 : raw_1.CreatedBy) !== null && _g !== void 0 ? _g : 'You',
                                        CommentType: (_h = raw_1 === null || raw_1 === void 0 ? void 0 : raw_1.CommentType) !== null && _h !== void 0 ? _h : CommentType.Code,
                                        CommentTypeDescription: (_j = raw_1 === null || raw_1 === void 0 ? void 0 : raw_1.CommentTypeDescription) !== null && _j !== void 0 ? _j : CommentType.Description,
                                        CreatedTime: (_l = (_k = raw_1 === null || raw_1 === void 0 ? void 0 : raw_1.CreatedTime) !== null && _k !== void 0 ? _k : raw_1 === null || raw_1 === void 0 ? void 0 : raw_1.CreatedDate) !== null && _l !== void 0 ? _l : new Date().toISOString(),
                                    }], false);
                            });
                        }
                        utility.alert(((_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.message) || 'Comment added successfully', constants.TOAST_TYPES.INFO);
                        return [2, true];
                    case 4:
                        utility.alert(((_f = response === null || response === void 0 ? void 0 : response.data) === null || _f === void 0 ? void 0 : _f.message) || 'Unable to add comment', constants.TOAST_TYPES.ERROR);
                        return [2, false];
                    case 5:
                        error_2 = _j.sent();
                        utility.alert(((_h = (_g = error_2 === null || error_2 === void 0 ? void 0 : error_2.response) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.message) || (error_2 === null || error_2 === void 0 ? void 0 : error_2.message) || 'Unable to add comment', constants.TOAST_TYPES.ERROR);
                        return [2, false];
                    case 6: return [2];
                }
            });
        });
    };
    var handleDrawerClose = function () { return setActiveDrawer(null); };
    var toleranceDetails = Array.isArray(appResp === null || appResp === void 0 ? void 0 : appResp.ContractToleranceHistory) && (appResp === null || appResp === void 0 ? void 0 : appResp.ContractToleranceHistory.length) > 0 ? appResp === null || appResp === void 0 ? void 0 : appResp.ContractToleranceHistory[0] : null;
    var renderDrawerContent = function () {
        switch (activeDrawer) {
            case 'CREDIT_CONDITIONS':
                return (React.createElement(Stack, { p: 2, pt: 2 },
                    React.createElement(CheckboxWrapper, null,
                        React.createElement(Box, { className: "chackBoxgroup", sx: { border: 'none !important' } },
                            React.createElement(FormGroup, null,
                                React.createElement(Grid, { container: true, spacing: 1 },
                                    React.createElement(Grid, { item: true, xs: 12 },
                                        React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { defaultChecked: true }), label: "ACH form required" })),
                                    React.createElement(Grid, { item: true, xs: 12 },
                                        React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { defaultChecked: true }), label: "ACH Payments required(ACH form Rep)" })),
                                    React.createElement(Grid, { item: true, xs: 12 },
                                        React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { defaultChecked: true }), label: "Finance Upfront Tax" })),
                                    React.createElement(Grid, { item: true, xs: 12 },
                                        React.createElement(FormControlLabel, { control: React.createElement(Checkbox, null), label: "Finance Upfront Tax" })),
                                    React.createElement(Grid, { item: true, xs: 12 },
                                        React.createElement(FormControlLabel, { control: React.createElement(Checkbox, null), label: "Finance Upfront Tax" })),
                                    React.createElement(Grid, { item: true, xs: 12 },
                                        React.createElement(FormControlLabel, { control: React.createElement(Checkbox, null), label: "Finance Upfront Tax" })),
                                    React.createElement(Grid, { item: true, xs: 12 },
                                        React.createElement(FormControlLabel, { control: React.createElement(Checkbox, null), label: "Finance Upfront Tax" })),
                                    React.createElement(Grid, { item: true, xs: 12 },
                                        React.createElement(FormControlLabel, { control: React.createElement(Checkbox, null), label: "Finance Upfront Tax" }))))))));
            case 'CONTRACT_TOLERANCE':
                return (React.createElement(Stack, { p: 2, pt: 2 },
                    React.createElement(Grid, { container: true, spacing: 2 },
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(TextBottomLine, { headingTitle: "Individual Details" })),
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(TextField, { label: "Approved Finance Amount", name: "DaysToExpire", isMandatoryField: false, placeholder: "Approved Finance Amount", fullWidth: true, value: "57,000.00", onChange: function () { }, onBlur: function () { }, type: "text", fontWeight: "600" })),
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(TextField, { label: "Minimum Yield", name: "DaysToExpire", isMandatoryField: false, placeholder: "Minimum Yield", fullWidth: true, value: "-10.000", onChange: function () { }, onBlur: function () { }, type: "text", fontWeight: "600" })),
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(AutoCompleteDD, { options: rolesList.status, displayKey: "Name", valueKey: "Id", label: "Maximum Term", placeholder: "Maximum Term", handleChange: function () { }, selectedValue: function () { }, name: "Status", isMandatoryField: false, handleBlur: function () { }, fontWeight: '600' })),
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(TextBottomLine, { headingTitle: "Contract  Values" })),
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(TextField, { label: "Approved Fund Amount", name: "DaysToExpire", isMandatoryField: false, placeholder: "Approved Fund Amount", fullWidth: true, value: "57,000.00", onChange: function () { }, onBlur: function () { }, type: "text", fontWeight: "600" })),
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(TextField, { label: "Current Yield", name: "DaysToExpire", isMandatoryField: false, placeholder: "Current Yield", fullWidth: true, value: "-10.000", onChange: function () { }, onBlur: function () { }, type: "text", fontWeight: "600" })),
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(AutoCompleteDD, { options: rolesList.status, displayKey: "Name", valueKey: "Id", label: "Contract Term", placeholder: "Contract Term", handleChange: function () { }, selectedValue: function () { }, name: "Status", isMandatoryField: false, handleBlur: function () { }, fontWeight: '600' })))));
            case 'COMMENTS':
                return (React.createElement(Stack, { p: 2, pt: 2 },
                    React.createElement(Grid, { container: true, spacing: 2 },
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(TextField, { label: "Subject", name: "commentSubject", isMandatoryField: false, placeholder: "Enter Subject", fullWidth: true, value: commentSubject, onChange: function (e) { return setCommentSubject(e.target.value); }, onBlur: function () { }, type: "text", fontWeight: "600" })),
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(TextField, { label: "Comment:", name: "commentText", isMandatoryField: false, placeholder: "Enter your comment here...", fullWidth: true, value: commentText, onChange: function (e) { return setCommentText(e.target.value); }, onBlur: function () { }, minRows: 7, multiline: true, type: "text", maxLength: 500, fontWeight: "600" })))));
            default:
                return null;
        }
    };
    var getContractToleranceValues = function (field) {
        var _a;
        if (field.isToleranceField && toleranceDetails && field && field.name in toleranceDetails) {
            return (_a = toleranceDetails[field.name]) !== null && _a !== void 0 ? _a : '';
        }
        return (mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData[field.name]) || '';
    };
    var handleDocumentClick = function (doc) {
        setShowExpandedDocuments(false);
        setActiveCompactPanel(null);
        if (onDocumentOpen) {
            onDocumentOpen(doc);
        }
    };
    var handleDownloadAllDocuments = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var txAspireOId, zip, usedFileNames, downloadedCount, _i, sortedDocuments_1, doc, fileName, apiResponse, uniqueFileName, suffix, dotIndex, error_3, zipBlob, error_4;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    event.stopPropagation();
                    txAspireOId = (_a = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _a === void 0 ? void 0 : _a.TxAspireOId;
                    if (!txAspireOId || isDownloadingAllDocuments || sortedDocuments.length === 0)
                        return [2];
                    setIsDownloadingAllDocuments(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 9, 10, 11]);
                    zip = new JSZip();
                    usedFileNames = new Set();
                    downloadedCount = 0;
                    _i = 0, sortedDocuments_1 = sortedDocuments;
                    _b.label = 2;
                case 2:
                    if (!(_i < sortedDocuments_1.length)) return [3, 7];
                    doc = sortedDocuments_1[_i];
                    if (!(doc === null || doc === void 0 ? void 0 : doc.DocumentIdentifier))
                        return [3, 6];
                    fileName = getDocumentName(doc) || "document-".concat(doc.DocumentIdentifier);
                    _b.label = 3;
                case 3:
                    _b.trys.push([3, 5, , 6]);
                    return [4, api_service.get({
                            endPoint: api_urls.GET_APP_DOCUMENTS,
                            payLoad: { TxAspireOId: txAspireOId, DocumentIdentifier: doc.DocumentIdentifier },
                            showLoader: false,
                            responseType: 'arraybuffer',
                        })];
                case 4:
                    apiResponse = _b.sent();
                    if (!((apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.data) instanceof ArrayBuffer))
                        return [3, 6];
                    uniqueFileName = fileName;
                    suffix = 1;
                    while (usedFileNames.has(uniqueFileName)) {
                        dotIndex = fileName.lastIndexOf('.');
                        uniqueFileName = dotIndex === -1
                            ? "".concat(fileName, " (").concat(suffix, ")")
                            : "".concat(fileName.slice(0, dotIndex), " (").concat(suffix, ")").concat(fileName.slice(dotIndex));
                        suffix += 1;
                    }
                    usedFileNames.add(uniqueFileName);
                    zip.file(uniqueFileName, apiResponse.data);
                    downloadedCount += 1;
                    return [3, 6];
                case 5:
                    error_3 = _b.sent();
                    return [3, 6];
                case 6:
                    _i++;
                    return [3, 2];
                case 7:
                    if (downloadedCount === 0) {
                        utility.alert('Unable to download documents.', constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    return [4, zip.generateAsync({ type: 'blob' })];
                case 8:
                    zipBlob = _b.sent();
                    downloadBlob(zipBlob, "".concat(txAspireOId, "-documents.zip"));
                    return [3, 11];
                case 9:
                    error_4 = _b.sent();
                    utility.alert('Unable to download all documents.', constants.TOAST_TYPES.ERROR);
                    return [3, 11];
                case 10:
                    setIsDownloadingAllDocuments(false);
                    return [7];
                case 11: return [2];
            }
        });
    }); };
    var handleExpandComments = function () {
        setShowExpandedDocuments(false);
        setShowExpandedComments(true);
        setShowDefaultView(false);
        setActiveCompactPanel(null);
    };
    var handleCompactPanelClose = function () {
        setShowExpandedDocuments(false);
        setShowExpandedComments(false);
        setShowDefaultView(false);
        setActiveCompactPanel(null);
    };
    var handleIconItemClick = function (key) {
        if (key === 'default') {
            setShowExpandedDocuments(false);
            setShowExpandedComments(false);
            setShowDefaultView(true);
            setActiveCompactPanel('default');
            return;
        }
        if (key === 'documents') {
            setShowExpandedDocuments(true);
            setShowExpandedComments(false);
            setShowDefaultView(false);
            setActiveCompactPanel(null);
            if (documents.length > 0) {
                setShowExpandedDocuments(true);
            }
            return;
        }
        if (key === 'conditions') {
            setShowExpandedDocuments(false);
            setShowExpandedComments(false);
            setShowDefaultView(true);
            setActiveCompactPanel('conditions');
            return;
        }
        if (key === 'reports') {
            if (!hasReportsTab) {
                return;
            }
            setShowExpandedDocuments(false);
            setShowExpandedComments(false);
            setShowDefaultView(true);
            setActiveCompactPanel('reports');
            return;
        }
        if (key === 'tolerance') {
            setShowExpandedDocuments(false);
            setShowExpandedComments(false);
            setShowDefaultView(true);
            setActiveCompactPanel('tolerance');
            return;
        }
        if (key === 'comments') {
            handleExpandComments();
        }
    };
    var iconItems = __spreadArray(__spreadArray([
        {
            key: 'default',
            label: 'Default View',
            icon: React.createElement(FormatListBulletedIcon, { fontSize: "small" }),
            active: activeCompactPanel === 'default',
        },
        {
            key: 'documents',
            label: 'Documents',
            icon: (React.createElement(DocumentsIcon, null)),
            active: activePreviewSection === 'documents',
        },
        {
            key: 'conditions',
            label: 'Credit Conditions',
            icon: React.createElement("span", { className: "icon-circle-dollar", style: { fontSize: 20, lineHeight: 1 } }),
            active: activeCompactPanel === 'conditions',
        }
    ], (hasReportsTab && !(roleType === "INT_SALESREP") ? [{
            key: 'reports',
            label: 'Credit Reports',
            icon: React.createElement("span", { className: "icon-Reload", style: { fontSize: 20, lineHeight: 1 } }),
            active: activeCompactPanel === 'reports' || activePreviewSection === 'reports',
        }] : []), true), [
        {
            key: 'tolerance',
            label: 'Credit Tolerance',
            icon: React.createElement(CreditToleranceIcon, null),
            active: activeCompactPanel === 'tolerance',
        },
        {
            key: 'comments',
            label: 'Comments',
            icon: React.createElement("span", { className: "icon-chat-bubble", style: { fontSize: 20, lineHeight: 1 } }),
            active: showExpandedComments,
        },
    ], false);
    var isCompactSpecificPanelOpen = Boolean(isDocumentPreviewOpen && activeCompactPanel);
    var showDocumentsCard = !isCompactSpecificPanelOpen || activeCompactPanel === 'default';
    var showConditionsCard = !isCompactSpecificPanelOpen || activeCompactPanel === 'default' || activeCompactPanel === 'conditions';
    var showReportsCard = (hasReportsTab && !(roleType === "INT_SALESREP")) && (!isCompactSpecificPanelOpen || activeCompactPanel === 'default' || activeCompactPanel === 'reports');
    var showToleranceCard = !isCompactSpecificPanelOpen || activeCompactPanel === 'default' || activeCompactPanel === 'tolerance';
    var showCommentsCard = !isCompactSpecificPanelOpen || activeCompactPanel === 'default';
    var compactPanelTitle = activeCompactPanel === 'conditions'
        ? 'Credit Conditions'
        : activeCompactPanel === 'reports'
            ? 'Credit Report'
            : activeCompactPanel === 'tolerance'
                ? 'Credit Tolerance'
                : 'Right Panel';
    if (showExpandedDocuments) {
        return (React.createElement(Stack, { gap: 0, sx: {
                backgroundColor: baseColors.fullWhite,
                pl: 2,
                pr: 1.5,
                pt: 2,
                height: '100%',
                overflowY: 'auto',
                display: 'flex',
                flexDirection: 'column',
            } },
            React.createElement(Stack, { direction: "row", justifyContent: "space-between", alignItems: "center", sx: { pb: 1.5, mb: 2 } },
                React.createElement(Typography, { variant: "h6", fontWeight: 700, color: baseColors.darkPreset[10] },
                    "Documents (",
                    tabbedDocuments.length,
                    ")"),
                React.createElement(CloseIcon, { onClick: handleCompactPanelClose, sx: {
                        cursor: 'pointer',
                        color: baseColors.darkPreset[10],
                        fontSize: 24,
                        '&:hover': { color: baseColors.successPreset[30] }
                    } })),
            documentTabs,
            React.createElement(Stack, { gap: 1.5, sx: { pb: 2, pt: 1.5 } }, tabbedDocuments.length > 0
                ? tabbedDocuments.map(function (doc) {
                    var _a, _b, _c;
                    return (React.createElement(Stack, { key: "".concat(String((_a = doc === null || doc === void 0 ? void 0 : doc.DocumentIdentifier) !== null && _a !== void 0 ? _a : ''), "-").concat(String((_b = doc === null || doc === void 0 ? void 0 : doc.FileName) !== null && _b !== void 0 ? _b : ''), "-").concat(String((_c = doc === null || doc === void 0 ? void 0 : doc.DocumentName) !== null && _c !== void 0 ? _c : '')), direction: "row", alignItems: "center", gap: 0.8, onClick: function () { return handleDocumentClick(doc); }, sx: {
                            p: 0.8,
                            borderRadius: '8px',
                            border: "1px solid ".concat(selectedDocumentId === (doc === null || doc === void 0 ? void 0 : doc.DocumentIdentifier) ? baseColors.successPreset[30] : baseColors.greyPreset[40]),
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                                borderColor: baseColors.successPreset[30],
                                transform: 'translateY(-1px)',
                            },
                        } },
                        renderDocumentTypeTag(doc, 28),
                        React.createElement(Stack, { gap: 0.5, sx: { flex: 1, pr: 1, minWidth: 0 } },
                            React.createElement(Tooltip, { title: getDocumentName(doc), placement: "top", arrow: true },
                                React.createElement(Typography, { variant: "body2", fontWeight: 500, color: baseColors.darkPreset[10], fontSize: 12, noWrap: true, sx: { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } }, getDocumentName(doc))),
                            React.createElement(Stack, { direction: "row", alignItems: "center", gap: 0.75, sx: { minWidth: 0 } },
                                React.createElement(Typography, { variant: "caption", color: baseColors.greyPreset[30], fontSize: 9, noWrap: true, sx: { overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0 } }, formatDocumentTimestamp(doc)),
                                renderDocumentTypeChip(doc)))));
                })
                : React.createElement(Typography, { variant: "body2", color: baseColors.greyPreset[30], fontStyle: "italic", textAlign: "center", py: 1 }, "No documents available"))));
    }
    if (showExpandedComments) {
        return (React.createElement(Stack, { sx: {
                backgroundColor: baseColors.fullWhite,
                height: '100%',
                overflow: 'hidden',
            } },
            React.createElement(BacklogComments, { comments: comments, onAddComment: handleAddComment, isExpanded: true, onClose: handleCompactPanelClose })));
    }
    if (isDocumentPreviewOpen && !showExpandedDocuments && !showExpandedComments && !showDefaultView && !activeCompactPanel) {
        return (React.createElement(Stack, { direction: { xs: 'row', lg: 'column' }, alignItems: "center", justifyContent: { xs: 'flex-start', lg: 'flex-start' }, gap: 1.8, sx: {
                width: '100%',
                backgroundColor: baseColors.fullWhite,
                height: '100%',
                px: { xs: 0.5, lg: 0 },
                py: 1,
                overflowY: 'auto',
                overflowX: 'hidden',
                transition: 'all 0.3s ease',
            } }, iconItems.map(function (item) { return (React.createElement(Tooltip, { key: item.key, title: item.label, placement: "right", arrow: true },
            React.createElement(Box, { onClick: function () { return handleIconItemClick(item.key); }, "aria-label": item.label, sx: {
                    width: 36,
                    height: 36,
                    borderRadius: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: item.active ? baseColors.successPreset[30] : 'transparent',
                    color: item.active ? baseColors.fullWhite : baseColors.successPreset[30],
                    flexShrink: 0,
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    '& svg': {
                        fontSize: 18,
                    },
                    '& span': {
                        fontSize: 18,
                    },
                } }, item.icon))); })));
    }
    return (React.createElement(Stack, { gap: 2.5, sx: {
            backgroundColor: baseColors.fullWhite,
            '& > .rightPanelSection ~ .rightPanelSection': {
                borderTop: "1px solid ".concat(baseColors.greyPreset[40]),
                pt: 2.5,
            },
            pl: 2,
            pr: 1.5,
            pt: 2,
            height: '100%',
            overflowY: 'auto',
            display: 'flex',
            flexDirection: 'column',
            pb: 2
        } },
        isCompactSpecificPanelOpen && activeCompactPanel !== 'default' ? (React.createElement(Stack, { direction: "row", justifyContent: "space-between", alignItems: "center", sx: { pb: 0.5, position: 'absolute', right: '15px' } },
            React.createElement(CloseIcon, { onClick: handleCompactPanelClose, sx: {
                    cursor: 'pointer',
                    color: baseColors.darkPreset[10],
                    fontSize: 24,
                    '&:hover': { color: baseColors.successPreset[30] },
                } }))) : null,
        !isDocumentPreviewOpen && actionRow && currentUserIsReviewer && (React.createElement(Box, { className: "rightPanelSection" },
            React.createElement(FundingLogActionsCard, { status: actionRow.status, tier: actionRow.assigneeTier, assigneeName: actionRow.assigneeName, currentUserRoleTier: currentUserRoleTier, canManage: canManageFundingActions, sx: { p: 0 }, onAssignToMyself: handleFundingAssignToMyself, onMoveToL2Manager: function () { return setPendingFundingAction('l2'); }, onMoveToSalesSupport: function () { return setPendingFundingAction('salesSupport'); }, onSetToFunded: function () { return setPendingFundingAction('funded'); }, onReassignToOther: handleOpenReassignPopup }))),
        showDocumentsCard ? (React.createElement(Stack, { gap: 1.5, className: "rightPanelSection" },
            React.createElement(Stack, { direction: "row", justifyContent: "space-between", alignItems: "center" },
                React.createElement(Stack, { direction: "row", alignItems: "center", gap: 1 },
                    React.createElement(SectionIconBadge, { bgColor: "#D7F5EC" },
                        React.createElement(DocumentsIcon, { fill: baseColors.successPreset[30] })),
                    React.createElement(Typography, { fontSize: '14px', fontWeight: 700, color: baseColors.darkPreset[10] }, "Documents")),
                React.createElement(Stack, { direction: "row", alignItems: "center", gap: 1.25 },
                    sortedDocuments.length > 0 && (React.createElement(Tooltip, { title: "Download All", placement: "top", arrow: true },
                        React.createElement("span", null,
                            React.createElement(IconButton, { size: "small", onClick: handleDownloadAllDocuments, disabled: isDownloadingAllDocuments, sx: { p: 0.5 } }, isDownloadingAllDocuments ? (React.createElement(CircularProgress, { size: 14 })) : (React.createElement(FileDownloadOutlinedIcon, { sx: { fontSize: 18, color: baseColors.successPreset[30] } })))))),
                    tabbedDocuments.length > visibleDocumentCount && (React.createElement(Typography, { variant: "body2", sx: {
                            cursor: 'pointer',
                            fontWeight: 600,
                            color: baseColors.successPreset[30],
                            '&:hover': { textDecoration: 'underline' }
                        }, onClick: function () {
                            setActiveCompactPanel(null);
                            setShowExpandedDocuments(true);
                        } },
                        "All ",
                        React.createElement("span", { style: { fontSize: 14, marginLeft: 4 } },
                            React.createElement(ArrowRightIcon, { width: 7, height: 7 })))))),
            documentTabs,
            React.createElement(Stack, { gap: 1.5 }, latestFourDocuments.length > 0
                ? latestFourDocuments.map(function (doc) {
                    var _a, _b, _c;
                    return (React.createElement(Stack, { key: "".concat(String((_a = doc === null || doc === void 0 ? void 0 : doc.DocumentIdentifier) !== null && _a !== void 0 ? _a : ''), "-").concat(String((_b = doc === null || doc === void 0 ? void 0 : doc.FileName) !== null && _b !== void 0 ? _b : ''), "-").concat(String((_c = doc === null || doc === void 0 ? void 0 : doc.DocumentName) !== null && _c !== void 0 ? _c : '')), direction: "row", alignItems: "center", gap: 1, onClick: function () { return handleDocumentClick(doc); }, sx: {
                            p: 1,
                            borderRadius: '8px',
                            border: "1px solid ".concat(selectedDocumentId === (doc === null || doc === void 0 ? void 0 : doc.DocumentIdentifier) ? baseColors.successPreset[30] : baseColors.greyPreset[40]),
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                                borderColor: baseColors.successPreset[30],
                                transform: 'translateY(-1px)',
                            },
                        } },
                        renderDocumentTypeTag(doc),
                        React.createElement(Stack, { gap: 0.5, sx: { minWidth: 0, flex: 1 } },
                            React.createElement(Tooltip, { title: getDocumentName(doc), placement: "top", arrow: true },
                                React.createElement(Typography, { variant: "body2", fontWeight: 500, color: baseColors.darkPreset[10], fontSize: 12, noWrap: true, sx: { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } }, getDocumentName(doc))),
                            React.createElement(Stack, { direction: "row", alignItems: "center", gap: 0.5, sx: { minWidth: 0 } },
                                React.createElement(Typography, { variant: "caption", color: baseColors.greyPreset[30], fontSize: 10, noWrap: true, sx: { overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0 } }, formatDocumentTimestamp(doc)),
                                renderDocumentTypeChip(doc)))));
                })
                : React.createElement(Typography, { variant: "body2", color: baseColors.greyPreset[30], fontStyle: "italic", textAlign: "center", py: 1 }, documentTab === 'email' ? 'No email documents available' : 'No documents available')))) : null,
        showConditionsCard ? (React.createElement(Stack, { gap: 1.5, className: "rightPanelSection" },
            React.createElement(Stack, { direction: "row", alignItems: "center", gap: 1 },
                React.createElement(SectionIconBadge, { bgColor: "#D7F5EC" },
                    React.createElement("span", { className: "icon-circle-dollar", style: { fontSize: 18, color: baseColors.successPreset[30], lineHeight: 1 } })),
                React.createElement(Typography, { fontSize: '14px', fontWeight: 600, color: baseColors.darkPreset[10] }, "Credit Conditions")),
            React.createElement(Stack, { gap: 1 }, ((_b = appResp === null || appResp === void 0 ? void 0 : appResp.ContractCreditConditions) === null || _b === void 0 ? void 0 : _b.length) > 0
                ? appResp.ContractCreditConditions.map(function (item) {
                    var _a;
                    return (React.createElement(ConditionRow, { key: String((_a = item === null || item === void 0 ? void 0 : item.CreditCondition) !== null && _a !== void 0 ? _a : '') },
                        React.createElement("span", { className: "icon-Warning conditionIcon" }),
                        React.createElement(Typography, { fontSize: '12px', fontWeight: 500, color: baseColors.bluePreset[40] },
                            item.CreditCondition,
                            item.Note ? (React.createElement(Box, { component: "span", sx: { fontStyle: 'italic' } }, " - (Note: ".concat(item.Note, ")"))) : null)));
                })
                : React.createElement(Typography, { fontSize: '12px', color: baseColors.greyPreset[30], fontStyle: "italic", textAlign: "center" }, "No credit conditions available")))) : null,
        showReportsCard ? (React.createElement(Stack, { gap: 1.5, className: "rightPanelSection" },
            React.createElement(Stack, { direction: "row", alignItems: "center", gap: 1 },
                React.createElement(SectionIconBadge, { bgColor: "#D7F5EC" },
                    React.createElement(PlagiarismOutlinedIcon, { sx: { fontSize: 18, color: baseColors.successPreset[30] } })),
                React.createElement(Typography, { fontSize: '14px', fontWeight: 700, color: baseColors.darkPreset[10] }, "Credit Reports")),
            React.createElement(Box, { sx: {
                    borderRadius: '8px',
                    px: 2,
                    py: 1.5,
                    backgroundColor: baseColors.greyPreset[55],
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1.25,
                } }, creditReportItems.length > 0 ? creditReportItems.map(function (item) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                return (React.createElement(Stack, { key: String((_c = (_b = (_a = item === null || item === void 0 ? void 0 : item.CreditReportOId) !== null && _a !== void 0 ? _a : item === null || item === void 0 ? void 0 : item.ReportName) !== null && _b !== void 0 ? _b : item === null || item === void 0 ? void 0 : item.label) !== null && _c !== void 0 ? _c : ''), direction: "row", justifyContent: "space-between", alignItems: "center" },
                    React.createElement(Tooltip, { title: (_f = (_e = (_d = item === null || item === void 0 ? void 0 : item.CreditBureau) !== null && _d !== void 0 ? _d : item === null || item === void 0 ? void 0 : item.CreditBureau) !== null && _e !== void 0 ? _e : item === null || item === void 0 ? void 0 : item.BureauCode) !== null && _f !== void 0 ? _f : '--', placement: "top", arrow: true },
                        React.createElement(Typography, { fontSize: '12px', fontWeight: 500, color: baseColors.darkPreset[10], noWrap: true, sx: { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '50%' } }, (_j = (_h = (_g = item === null || item === void 0 ? void 0 : item.CreditBureau) !== null && _g !== void 0 ? _g : item === null || item === void 0 ? void 0 : item.CreditBureau) !== null && _h !== void 0 ? _h : item === null || item === void 0 ? void 0 : item.BureauCode) !== null && _j !== void 0 ? _j : '--')),
                    React.createElement(Typography, { fontSize: '12px', color: baseColors.successPreset[30], fontWeight: 700, sx: { cursor: 'pointer' }, onClick: function () { return onCreditReportOpen === null || onCreditReportOpen === void 0 ? void 0 : onCreditReportOpen(item); } }, "Detailed Report")));
            }) : (React.createElement(Typography, { variant: "body2", color: baseColors.greyPreset[30], fontStyle: "italic", textAlign: "center" }, "No credit reports available"))))) : null,
        showCommentsCard ? (React.createElement(Stack, { className: "rightPanelSection" },
            React.createElement(BacklogComments, { comments: comments, onAddComment: handleAddComment, onExpand: handleExpandComments, maxListHeight: commentsListMaxHeight }))) : null,
        showToleranceCard ? (React.createElement(Stack, { gap: 1.5, className: "rightPanelSection" },
            React.createElement(Stack, { direction: "row", alignItems: "center", gap: 1 },
                React.createElement(SectionIconBadge, { bgColor: "#D7F5EC" },
                    React.createElement(TuneIcon, { sx: { fontSize: 18, color: baseColors.successPreset[30] } })),
                React.createElement(Typography, { fontSize: '14px', fontWeight: 700, color: baseColors.darkPreset[10] }, "Credit Tolerance")),
            React.createElement(Stack, { gap: 1.5 }, formSections.map(function (section) { return (React.createElement(Box, { key: section.label, sx: { border: "1px solid ".concat(baseColors.greyPreset[40]), borderRadius: '8px', overflow: 'hidden', width: '100%' } },
                React.createElement(Box, { sx: { px: 2, py: 1, backgroundColor: baseColors.greyPreset[55] } },
                    React.createElement(Typography, { variant: "subtitle2", fontWeight: 600, color: baseColors.darkPreset[10] }, section.label)),
                React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1.5, px: 2, py: 1.5 } },
                    React.createElement(Box, { sx: { flex: 1, display: 'flex', justifyContent: 'space-between' } },
                        React.createElement(Stack, null,
                            React.createElement(Typography, { variant: "caption", color: baseColors.greyPreset[30] }, "Tolerance:"),
                            React.createElement(Typography, { variant: "body2", fontWeight: 500, color: baseColors.darkPreset[10] }, getContractToleranceValues(section.fields[0]) || '--')),
                        React.createElement(Stack, { alignItems: "flex-end" },
                            React.createElement(Typography, { variant: "caption", color: baseColors.greyPreset[30] }, "Contract:"),
                            React.createElement(Typography, { variant: "body2", fontWeight: 500, color: baseColors.darkPreset[10] }, getContractToleranceValues(section.fields[1]) || '----')))))); })))) : null,
        React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.EVENT_NOT_ALLOWED, titleText: "Unable to Assign", message: "This account is not present in Aspire.", acceptBtnText: "OK", open: isFundingAssignErrorPopupOpen, acceptCallBack: function () { return setIsFundingAssignErrorPopupOpen(false); } }),
        pendingFundingAction && (React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.UNSAVED_DATA_WARNING, titleText: pendingFundingAction === 'l2'
                ? ((actionRow === null || actionRow === void 0 ? void 0 : actionRow.assigneeTier) === 'L1' ? 'Reassign for Final Reviewer?' : 'Assign to Final Review?')
                : pendingFundingAction === 'salesSupport'
                    ? 'Return to Sales Support?'
                    : 'Set to Fund?', message: pendingFundingAction === 'l2'
                ? ((actionRow === null || actionRow === void 0 ? void 0 : actionRow.assigneeTier) === 'L1'
                    ? 'Are you sure you want to reassign this contract to the Final Reviewer?'
                    : 'Are you sure you want to assign this contract to Final Review?')
                : pendingFundingAction === 'salesSupport'
                    ? 'Are you sure you want to return this contract to Sales Support?'
                    : 'Are you sure you want to set this contract to Fund? This is irreversible once submitted.', acceptBtnText: "Yes", denyBtnText: "No", open: Boolean(pendingFundingAction), acceptCallBack: handleConfirmFundingAction, denyCallBack: function () { return setPendingFundingAction(null); }, cancelCallBack: function () { return setPendingFundingAction(null); } })),
        actionRow && (React.createElement(FundingLogReassignPopup, { open: isReassignPopupOpen, onClose: function () { return setIsReassignPopupOpen(false); }, contractId: actionRow.contractId, customerName: actionRow.customerName, members: cmMembers, isLoadingMembers: isLoadingCmMembers, isSubmitting: isReassignSubmitting, onReassign: handleReassignConfirm }))));
};
export default RightSection;
